import { useState } from 'react';
import { postClientApplication, signClientApplicationUpload } from '../../../api/Rover/clientApplication';
import handGreystoneLogo from '../../../images/logos/hand-greystone-logo.png';
import { MultiStepApplicationProvider } from '../../../store/Context/MultiStepApplicationsProvider';
import ApplicationForm from '../ApplicationForm';
import { equityInActionApplicationSteps } from '../ApplicationForm/templates/handhousing';
import SubmitSuccess from '../SubmitSuccess';
import { validationSchema } from './validationSchema';

interface SubmitPayload {
  formData: any;
  files: any[];
}
const defaultValues: IEquityInAction = {
  orgInfo: {
    businessName: '',
    businessAddress: '',
    businessCity: '',
    state: '',
    zipCode: '',
    businessPhone: '',
    website: '',
    establishedDate: '',
    leadContact: '',
    phone: '',
    email: '',
    yearsInDevelopment: 0,
    ownOperateAffordableProperties: '',
    isHandMember: '',
    haveWorkedWithGreystone: '',
    canHelp: '',
    capitalAmount: 0,
    greystoneHelp: [],
    socialDesignation: '',
    legalStatus: '',
    sponsors: [
      {
        name: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        ownershipPercent: 0,
      },
    ],
  },
  potentialProject: {
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    dealType: '',
    proposedUnits: '',
    byRight: '',
    constructionType: '',
    acquisitionType: '',
    siteControlStatus: '',
    acquisitionCost: 0,
    developmentCost: 0,
    preDevelopmentCost: 0,
    moreInfo: '',
    financingUse: [],
  },
  orgExperience: {
    priorProjects: [
      {
        address: '',
        city: '',
        state: '',
        zipCode: '',
        projectType: '',
        constructionType: '',
        completionDate: '',
        status: '',
        projectCost: 0,
      },
    ],
  },
};

const HandHousingFormBase = () => {
  const [completed, setCompleted] = useState<boolean>(false);
  const onSubmit = async (payload: SubmitPayload) => {
    const { formData, files } = payload;
    const { orgInfo, orgExperience, potentialProject } = formData;

    let organizationAddress = `${orgInfo.businessAddress}, `;
    organizationAddress += `${orgInfo.businessCity}, `;
    organizationAddress += `${orgInfo.state}, `;
    organizationAddress += `${orgInfo.zipCode}, `;

    let sponsorAddr = `${orgInfo.sponsors[0].address}, `;
    sponsorAddr += `${orgInfo.sponsors[0].city}, `;
    sponsorAddr += `${orgInfo.sponsors[0].state}, `;
    sponsorAddr += `${orgInfo.sponsors[0].zipCode}, `;

    const clientApplication = {
      orgName: orgInfo.businessName,
      orgAddress: organizationAddress,
      sponsor: orgInfo.sponsors[0].name,
      sponsorAddress: sponsorAddr,
      amountRequested: orgInfo.capitalAmount,
      socialDesignation: orgInfo.socialDesignation,
      files,
      email: orgInfo.email,
      contactName: orgInfo.leadContact,
      program: 'Equity in Action',
      responseDays: '14',
      orgInfo,
      orgExperience: { ...orgExperience, potentialProject },
      financialRequest: {},
      disclosuresReferences: {},
    };
    return postClientApplication({ data: clientApplication });
  };
  if (completed) {
    return <SubmitSuccess message='Thank you for your interest in Equity in Action Program.' />;
  }
  return (
    <ApplicationForm
      title='Equity in Action'
      logo={handGreystoneLogo}
      validationSchema={validationSchema as any}
      signAsset={signClientApplicationUpload}
      steps={equityInActionApplicationSteps}
      onSubmit={onSubmit}
      onSuccess={() => {
        setCompleted(true);
      }}
    />
  );
};

export const HandHousingForm = () => (
  <MultiStepApplicationProvider initialValues={defaultValues}>
    <HandHousingFormBase />
  </MultiStepApplicationProvider>
);
